<template>
  <v-row no-gutters class="chat-widget">
    <v-col cols="auto">
      <v-menu ref="dropdown_menu" transition="slide-y-transition" offset-y bottom width="10.625rem" :close-on-content-click="true" content-class="dropdown-menu">
        <template v-slot:activator="{ props }">
          <v-row no-gutters align="center" class="dropdown-btn" v-bind="props">
            {{ title ? title : $vuetify.locale.t('$vuetify.__Dropdown.select') }}
            <v-icon style="margin-left: 1rem">mdi-chevron-down</v-icon>
          </v-row>
        </template>
        <v-list min-width="162" aria-label="dropdown-list-btn" role="button">
          <!-- Rename Button -->
          <v-list-item v-for="(button, i) in buttons" :key="i" class="text-none dropdown-menu-item" @click="click(button)">
            {{ button.title }}
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script setup>
// Import modules
import { defineProps } from 'vue'
import { useStore } from 'vuex'

// Init modules
const store = useStore()

// Props
const { buttons, title } = defineProps({ buttons: Array, title: String })

// Methods
const click = ({ type, title, value }) => {
  if (type === 'web_url') window.open(value, '_blank')
  else store.dispatch('sendMessageToSocket', { title, value })
}
</script>

<style scope>
.dropdown-btn {
  height: 3rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  padding: 0.75rem 1rem;
  color: #1a1a1a !important;
  font-weight: 700;
  font-size: 0.9375rem;
  line-height: 1.375rem;
  cursor: pointer;
}

.dropdown-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
}

.dropdown-menu {
  box-shadow: 0px 0.25rem 0.3125rem rgba(0, 0, 0, 0.14), 0px 0.0625rem 0.625rem rgba(0, 0, 0, 0.12), 0px 0.125rem 0.25rem rgba(0, 0, 0, 0.2) !important;
  border-radius: 0.5rem !important;
  z-index: 1000 !important;
  max-height: calc(100% - 10rem);
  background: #ffffff;
  overflow-y: overlay;
}

.dropdown-menu-item {
  height: 3.375rem;
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.375rem;
  letter-spacing: 0.01875rem;
  color: #1b1b1b !important;
}

.dropdown-menu-item:not(:first-child) {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
